import React from "react";
import DemoPage from "@/components/DemoPage";

const Demo = () => (
  <DemoPage
    seo={{
      title: "Demo: HCFA / CMS-1500 Extraction | See Hewto.ai in Action",
      description:
        "Watch Hewto.ai capture, validate, and structure data from an HCFA / CMS-1500 claim form in real time. Book a personalized demo on your own claim documents.",
      keywords:
        "hcfa cms-1500 demo, cms 1500 ocr demo, healthcare document ai demo, claim ocr demo, medical document extraction demo",
      canonical: "https://www.hewto.ai/demo/hcfa-cms-1500",
    }}
    heading="Demo"
    intro="Automate data extraction & entry with Hewto.ai. Our AI captures, validates, and organizes data from any document instantly — faster, smarter, and error-free."
    videoId="YGDJJK3R5DM"
    videoTitle="Hewto.ai — Handwritten HCFA / CMS-1500 demo"
    source="demo_hcfa_cms1500"
  />
);

export default Demo;
